import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { catchError, map, of } from 'rxjs';

import { RedirectBackService } from '@personal-area/global/navigation';

import { AuthService } from './auth.service';

export const authGuard: CanMatchFn = (route, segments) => {
  const authService = inject(AuthService);
  const redirectBackService = inject(RedirectBackService);

  // user has a valid access token
  if (authService.isLoggedIn) {
    return true;
  }

  // can update access token using refresh token
  if (authService.isAccessTokenExpired && !authService.isRefreshTokenExpired) {
    return authService.refreshAuthToken().pipe(
      catchError(() => {
        redirectBackService.redirectLogin();
        return of(false);
      }),
      map(() => true),
    );
  }

  // user has an expired refresh token
  redirectBackService.redirectLogin();
  return false;
};
